<template>
  <div class="garantie-view">
    <template v-if="isBusy">
      <Preloader />
    </template>
    <template v-else>
      <div class="garantie-view__head">
        <div class="garantie-view__head--icon" @click="$router.push('/devis')" v-if="showRetourButton">
          <font-awesome-icon prefix="fas" icon="arrow-circle-left" />
          Retour
        </div>
      </div>
      <div class="garantie-view__head">
        <div class="garantie-view__head--title">Devis en ligne</div>
      </div>
      <div class="garantie-view__body">
        <div class="garantie-view__body__block">
          <div class="garantie-view__body__block--title">
            RAPPEL DES INFORMATIONS COMMUNIQUÉES
          </div>
          <div class="garantie-view__body__block--content" v-if="insurance.client">
            <div class="title">Vos coordonnées :</div>
            <div class="row">
              <template v-if="+insurance.client.civility !== CLIENT_CIVILITY.SOCIETE.ID">
                <div class="col-12">
                  <div class="field">
                    <div class="field__label">Civilité :</div>
                    <div class="field__value">
                      {{ parseCivility(insurance.client.civility) }}
                    </div>
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="col-12">
                  <div class="field">
                    <div class="field__label">Société :</div>
                    <div class="field__value">
                      {{ insurance.client.name_of_signatory }}
                    </div>
                  </div>
                </div>
              </template>

              <template v-if="+insurance.client.civility !== CLIENT_CIVILITY.SOCIETE.ID">
                <div class="col-12 col-md-6">
                  <div class="field">
                    <div class="field__label">Nom :</div>
                    <div class="field__value">
                      {{ insurance.client.last_name }}
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md-6" v-if="insurance.client.first_name">
                  <div class="field">
                    <div class="field__label">Prénom :</div>
                    <div class="field__value">
                      {{ insurance.client.first_name }}
                    </div>
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="col-12 col-md-6">
                  <div class="field">
                    <div class="field__label">Nom du signataire :</div>
                    <div class="field__value">
                      {{ insurance.client.last_name }}
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md-6" v-if="insurance.client.first_name">
                  <div class="field">
                    <div class="field__label">Prénom du signataire :</div>
                    <div class="field__value">
                      {{ insurance.client.first_name }}
                    </div>
                  </div>
                </div>
              </template>
              <div class="col-12 col-md-6">
                <div class="field">
                  <div class="field__label">Adresse :</div>
                  <div class="field__value">{{ insurance.client.address }}</div>
                </div>
              </div>

              <div class="col-12 col-md-6">
                <div class="field">
                  <div class="field__label">Code postal :</div>
                  <div class="field__value">{{ insurance.client.zip }}</div>
                </div>
              </div>

              <div class="col-12 col-md-6">
                <div class="field">
                  <div class="field__label">Ville :</div>
                  <div class="field__value">{{ insurance.client.city }}</div>
                </div>
              </div>

              <div class="col-12 col-md-6">
                <div class="field">
                  <div class="field__label">Téléphone :</div>
                  <div class="field__value">{{ insurance.client.tel }}</div>
                </div>
              </div>

              <div class="col-12 col-md-6">
                <div class="field">
                  <div class="field__label">Fax :</div>
                  <div class="field__value">{{ insurance.client.fax }}</div>
                </div>
              </div>

              <div class="col-12 col-md-6">
                <div class="field">
                  <div class="field__label">Email :</div>
                  <div class="field__value">{{ insurance.client.email }}</div>
                </div>
              </div>

              <div class="col-12 col-md-6"
                v-if="insurance.client && insurance.client.birthday && insurance.client.birthday != '1900-01-01 00:00:00'">
                <div class="field">
                  <div class="field__label">Date de naissance :</div>
                  <div class="field__value">{{ parseBirthDate(insurance.client.birthday) }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="divider"></div>

          <!--DETAILS-->

          <div class="garantie-view__body__block--content" v-if="insurance.details">
            <div class="title">Votre moto :</div>

            <div class="row">
              <div class="col-12">
                <div class="field row">
                  <div class="field__label col-12 col-sm-4">
                    <b>Garantie :</b>
                  </div>
                  <div class="field__value col-12 col-sm-8">
                    {{ parseGarantie(insurance.details.garantie) }}
                  </div>
                </div>
              </div>

              <div class="col-12">
                <div class="field row">
                  <div class="field__label col-12 col-sm-4">
                    <b>Immatriculation :</b>
                  </div>
                  <div class="field__value col-12 col-sm-8">
                    {{ insurance.details.registration }}
                  </div>
                </div>
              </div>

              <div class="col-12">
                <div class="field row">
                  <div class="field__label col-12 col-sm-4">
                    <b>Numéro de série :</b>
                  </div>
                  <div class="field__value col-12 col-sm-8">
                    {{ insurance.details.serial_number }}
                  </div>
                </div>
              </div>

              <div class="col-12">
                <div class="field row">
                  <div class="field__label col-12 col-sm-4">
                    <b>Marque :</b>
                  </div>
                  <div class="field__value col-12 col-sm-8">
                    {{ parseCarBrand(insurance.details.car_brand) }}
                  </div>
                </div>
              </div>

              <div class="col-12">
                <div class="field row">
                  <div class="field__label col-12 col-sm-4">
                    <b>Modèle :</b>
                  </div>
                  <div class="field__value col-12 col-sm-8">
                    {{ insurance.details.modele_porteur }}
                  </div>
                </div>
              </div>

              <div class="col-12">
                <div class="field row">
                  <div class="field__label col-12 col-sm-4">
                    <b>Appellation commerciale :</b>
                  </div>
                  <div class="field__value col-12 col-sm-8">
                    {{ insurance.details.app_commercial }}
                  </div>
                </div>
              </div>

              <div class="col-12">
                <div class="field row">
                  <div class="field__label col-12 col-sm-4">
                    <b>Date de 1&egrave;re mise en circulation :</b>
                  </div>
                  <div class="field__value col-12 col-sm-8">
                    {{ parseSaleDate(insurance.details) }}
                  </div>
                </div>
              </div>

              <div class="col-12">
                <div class="field row">
                  <div class="field__label col-12 col-sm-4">
                    <b>Kilométrage : </b>
                  </div>
                  <div class="field__value col-12 col-sm-8">
                    {{ insurance.details.km_sale_day }}
                  </div>
                </div>
              </div>

              <div class="col-12">
                <div class="field row">
                  <div class="field__label col-12 col-sm-4">
                    <b>Cylindrée :</b>
                  </div>
                  <div class="field__value col-12 col-sm-8">
                    {{ parseCylinder(insurance.details.cylinder) }}
                  </div>
                </div>
              </div>

              <div class="col-12">
                <div class="field row">
                  <div class="field__label col-12 col-sm-4">
                    <b>Date d'effet :</b>
                  </div>
                  <div class="field__value col-12 col-sm-8">
                    {{
                      moment(insurance.details.effective_date).format("DD/MM/Y")
                    }}
                  </div>
                </div>
              </div>

              <div class="col-12">
                <div class="field row">
                  <div class="field__label col-12 col-sm-4"><b>Durée :</b></div>
                  <div class="field__value col-12 col-sm-8">
                    {{ parseDuration(insurance.details.duration) }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="garantie-view__body__block--warning" v-if="numberOfDuplicates > 0">
            Attention ! Un contrat a déjà été saisi avec ce nom et ce numéro
            d’immatriculation.
          </div>

          <div class="garantie-view__body__block--link">
            <router-link :to="/garantie-moto/ + $route.params.id">Cliquer ici pour modifier vos coordonnées
            </router-link>
          </div>
        </div>
      </div>
      <div class="garantie-view__body">
        <div class="garantie-view__body__block">
          <div class="garantie-view__body__block--title">
            VOUS AVEZ CHOISI L'ASSURANCE MOTO
          </div>
          <div class="garantie-view__body__block--content insurance-info">
            <div class="insurance-info__title rem-18">
              <b>Durée et prise d'effet</b>
            </div>
            <div class="insurance-info__text font-weight-bold rem-14" v-if="mechanicCode != '705223'">
              Sous réserve du paiement de la prime et de l'acceptation de la
              garantie par
              <b>Dynassurances</b>, la garantie s'applique suivant la durée
              précisée aux conditions particulières du contrat et prendra fin
              automatiquement à 24 heures jour pour jour selon les dates
              indiquées sur le certificat de garantie. Cependant la garantie
              prendra fin de plein droit avant son terme :
            </div>
            <div class="insurance-info__text font-weight-bold rem-14" v-else>
              Sous réserve du paiement de la prime et de l'acceptation de la
              garantie, la garantie s'applique suivant la durée précisée aux
              conditions particulières du contrat et prendra fin automatiquement
              à 24 heures jour pour jour selon les dates indiquées sur le
              certificat de garantie. Cependant la garantie prendra fin de plein
              droit avant son terme :
            </div>
            <ul class="insurance-info__list font-weight-bold rem-14">
              <li class="insurance-info__list--item">
                en cas de destruction du véhicule, quelle qu'en soit la cause,
                par résiliation,
              </li>
              <li class="insurance-info__list--item">
                en cas de déchéance du bénéficiaire de la garantie pour non
                respect des prescriptions du constructeur sur l'usage pour
                lequel le véhicule est conçu.
              </li>
            </ul>
          </div>
          <div class="divider"></div>

          <div class="garantie-view__body__block--content price-block">
            <div class="description">
              <div class="row mt-3">
                <div class="col-12 col-md-6">
                  <div class="label">
                    <div class="label--bold">
                      Prime totale T.T.C. (&euro;) *
                    </div>
                  </div>
                </div>

                <template v-if="getPrice">
                  <div class="col-12 col-md-6">
                    <div class="label">
                      <div class="label--bold">
                        {{ getPrice }}
                      </div>
                    </div>
                  </div>
                </template>
                <template v-else>
                  <div class="col-12 col-md-6">
                    <div class="label">
                      <div class="label--red" v-if="mechanicCode != '705223'">
                        Les critères du véhicule ne permettent pas de souscrire
                        à la garantie choisie.<br />
                        Pour effectuer une demande de dérogation, veuillez
                        adresser le contrôle technique à l’adresse
                        <a href="mailto:servicetechnique@dynassurances.fr">servicetechnique@dynassurances.fr</a>
                        avec les informations suivantes :
                        <ul>
                          <li>Immatriculation du véhicule</li>
                          <li>Votre code garage</li>
                        </ul>
                      </div>
                      <div class="label--red" v-else>
                        Les critères du véhicule ne permettent pas de souscrire
                        à la garantie choisie.<br />
                        Pour effectuer une demande de dérogation, veuillez
                        adresser le contrôle technique avec les informations
                        suivantes :
                        <ul>
                          <li>Immatriculation du véhicule</li>
                          <li>Votre code garage</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </template>
              </div>

              <div class="row mt-3" v-if="insurance && insurance.assistance_price > 0">
                <div class="col-12 col-md-6">
                  <div class="label">
                    <div class="label--bold">Dont pack assitance</div>
                  </div>
                </div>

                <div class="col-12 col-md-6">
                  <div class="label">
                    <div class="label--bold">
                      {{
                        roundEURWithoutSymbol(
                          insurance.assistance_price
                        ).replace(".", ",")
                      }}
                      €
                    </div>
                  </div>
                </div>
              </div>

              <div class="agenda mt-3">
                <div class="agenda--small">
                  * Frais de dossier et taxe attentats inclus
                </div>
              </div>
              <div class="mt-3">
                Pour nous contacter ou souscrire : 01 48 89 57 57
              </div>

              <div class="divider mt-3 mb-3"></div>
            </div>
          </div>

          <div class="insurance-info">
            <div class="insurance-info__buttons">
              <div class="insurance-info__buttons__item insurance-info__buttons__item--50 text-sm-right">
                <div class="insurance-info__buttons--wrapper">
                  <a href="#" @click.prenevt="printInsurance()" class="blue">Imprimer le détail de la garantie</a>
                  <div class="ball-anchor blue"></div>
                </div>
              </div>
              <div class="insurance-info__buttons__item insurance-info__buttons__item--50 text-sm-left">
                <div class="insurance-info__buttons--wrapper">
                  <a href="#" @click.prevent="getFrontPdf()" class="green">Sauvegarder sur mon ordinateur</a>
                  <div class="ball-anchor green"></div>
                </div>
              </div>
            </div>
          </div>

          <div class="garantie-view__body__block mt-3">
            <div class="print-page-break"></div>

            <!--<div class="print-page-break"></div>-->
            <div class="garantie-view__body__block--title new-page-padding">
              Garanties accordées
            </div>

            <div class="garantie-view__body__block--content">
              <div class="description">
                <div class="list mt-3">
                  <!--                                    <Accordes :type="+insurance.details.garantie"/>-->
                  <Accordes :insurance="insurance" />
                </div>
              </div>
            </div>
            <!--<div class="garantie-view__body__block&#45;&#45;content">-->
            <!--<div class="description">-->
            <!--<div class="list mt-3">-->
            <!--<ul class="list__ul">-->
            <!--<li>-->
            <!--<b>Moteur :</b>-->
            <!--<div>-->
            <!--Toutes les pièces lubrifiées du bloc cylindre et de la culasse, les-->
            <!--culbuteurs et tiges de culbuteurs, les soupapes et guides de soupapes,-->
            <!--les joints moteur de culasse, la culasse, les tiges, les poussoirs,-->
            <!--l'arbre à cames, les pignons de distribution, les couronnes de volant,-->
            <!--la pompe à huile, les pistons et les axes de pistons, les segments, les-->
            <!--cylindres, les coussinets, le vilebrequin et les paliers, l'entraînement-->
            <!--du distributeur, les collecteurs d'admission et d'échappement.-->
            <!--</div>-->
            <!--</li>-->
            <!--<li>-->
            <!--<b>Boîte de vitesses :</b>-->
            <!--<div>-->
            <!--<b>Manuelle</b> : Toutes les défaillances internes, les pignons, les-->
            <!--arbres-->
            <!--sélecteurs synchros.-->
            <!--</div>-->
            <!--<div>-->
            <!--<b>Automatique</b> : Les pignons, la pompe à huile, les bagues et les-->
            <!--arbres de-->
            <!--roues, les cardans, les couples coniques, les différentiels.-->
            <!--</div>-->
            <!--</li>-->
            <!--<li><b>Dispositif de transmission :</b>-->
            <!--<div>-->
            <!--L'arbre de transmission, les arbres de roues, les cardans, les couples-->
            <!--coniques, les différentiels.-->
            <!--</div>-->
            <!--</li>-->
            <!--<li><b>Système d'alimentation :</b>-->
            <!--<div>-->
            <!--Le carburateur, la pompe à injection, la pompe électrique-->
            <!--d'alimentation, le bloc d'injection et le turbo.-->
            <!--</div>-->
            <!--</li>-->
            <!--<li><b>Système de refroidissement :</b>-->
            <!--<div>-->
            <!--Les différentes pompes, le thermostat, le ventilateur du circuit de-->
            <!--refroidissement, le refroidisseur d'huile moteur et la boîte de-->
            <!--vitesses, les radiateurs de refroidissement, l'échangeur air-air.-->
            <!--</div>-->
            <!--</li>-->
            <!--<li><b>Equipement électrique :</b>-->
            <!--<div>-->
            <!--Le démarreur, l'alternateur, l'allumeur, le bloc d'allumage, le système-->
            <!--électronique d'injection, le moteur d'essuie-glace de série uniquement,-->
            <!--les lève-glaces électriques et le moteur de lève-glaces de série-->
            <!--uniquement, la fermeture centralisée des portes, toutes les commandes et-->
            <!--témoins du tableau de bord et la climatisation si d'origine.-->
            <!--</div>-->
            <!--</li>-->
            <!--<li><b>Système de freinage :</b>-->
            <!--<div>-->
            <!--Les organes de freins, le maître cylindre, le servofrein, les cylindres-->
            <!--de roues, la pompe à vide à l'exception des pièces en friction, les-->
            <!--étriers de freins à disques, les limiteurs ou régulateurs de charge.-->
            <!--</div>-->
            <!--</li>-->
            <!--<li><b>Système de freinage anti-blocage des roues :</b>-->
            <!--<div>-->
            <!--Le calculateur, les capteurs et le bloc hydraulique.-->
            <!--</div>-->
            <!--</li>-->
            <!--<li><b>Dispositif de direction :</b>-->
            <!--<div>-->
            <!--La mécanique ou assistée, y compris tous les organes internes y compris-->
            <!--la pompe hydraulique, le boîtier de renvoi ou intermédiaire, la-->
            <!--canalisation, le réservoir, les durites de direction assistée.-->
            <!--</div>-->
            <!--</li>-->
            <!--<li><b>Dispositif de suspension :</b>-->
            <!--<div>-->
            <!--Les ressorts, la barre stabilisatrice, les articulations, les bras de-->
            <!--suspension, les rotules et la suspension hydraulique, sauf les joints et-->
            <!--les conduites de suspension.-->
            <!--</div>-->
            <!--</li>-->
            <!--<li><b>Dispositif d'embrayage :</b>-->
            <!--<div>-->
            <!--Le mécanisme et la fourchette.-->
            <!--</div>-->
            <!--</li>-->
            <!--<li><b>Important :</b>-->
            <!--<div>-->
            <!--Cette garantie est réservée aux propriétaires de véhicules V.P n'ayant-->
            <!--pas excéder la limite d'âge à la souscription qui est de 5 ans, étant-->
            <!--une cylindrée, au maximum, de 2.5 litres et n'excédant pas la limite-->
            <!--kilométrique à la souscription qui est de 110 000 km pour la garantie 6-->
            <!--mois, de 90 000 km pour la garantie 12 mois et de 60 000 km pour la-->
            <!--garantie 24 mois.-->
            <!--</div>-->
            <!--</li>-->
            <!--</ul>-->
            <!--</div>-->
            <!--</div>-->
            <!--</div>-->
          </div>

          <!--<div class="insurance-info">-->
          <!--<div class="insurance-info__buttons">-->
          <!--<div class="insurance-info__buttons__item insurance-info__buttons__item&#45;&#45;33">-->
          <!--<div class="insurance-info__buttons&#45;&#45;wrapper">-->
          <!--<a href="#" @click.prevent="getConfirmationPDF()" class="purple">Confirmation de garantie</a>-->
          <!--<div class="ball-anchor purple"></div>-->
          <!--</div>-->
          <!--</div>-->
          <!--</div>-->
          <!--</div>-->

          <div class="insurance-info">
            <div class="insurance-info__buttons">
              <div class="insurance-info__buttons__item insurance-info__buttons__item--33">
                <div class="insurance-info__buttons--wrapper">
                  <router-link :to="/garantie-moto/ + $route.params.id" class="blue">Modifier
                  </router-link>
                  <div class="ball-anchor blue"></div>
                </div>
              </div>
              <div class="insurance-info__buttons__item insurance-info__buttons__item--33" v-if="getGarantiePrice">
                <div class="insurance-info__buttons--wrapper">
                  <a href="#" @click.prevent="checkSubscription(insurance, getPDF)" class="purple">Souscrire à la
                    garantie</a>
                  <div class="ball-anchor purple"></div>
                </div>
              </div>
              <!-- <div
                class="insurance-info__buttons__item insurance-info__buttons__item--33"
                v-if="insurance.mechanic.client_payment == 1"
              >
                <div class="col-6 text-right insurance-info__buttons--wrapper">
                              <a href="#" @click.prenevt="checkSubscription(insurance, resendEmail)" class="green">Envoyer devis par email</a>
                              <div class="ball-anchor green"></div>
                            </div>
                <div
                  class="col-6 text-right insurance-info__buttons--wrapper"
                  v-if="getPrice"
                >
                  <a
                    href="#"
                    @click.prevent="checkSubscription(insurance, resendEmail)"
                    class="green"
                    >Envoyer devis par email</a
                  >
                  <div class="ball-anchor green"></div>
                </div>
                <div
                  class="col-6 text-right insurance-info__buttons--wrapper"
                  v-else
                >
                  <a href="#" @click.prevent="confirmSubscription" class="green"
                    >Envoyer devis par email</a
                  >
                  <div class="ball-anchor green"></div>
                </div>
              </div> -->
              <div class="insurance-info__buttons__item insurance-info__buttons__item--33">
                <div class="insurance-info__buttons--wrapper">
                  <router-link v-if="!showRetourButton" :to="'/'" class="black">Fermer</router-link>
                  <router-link v-else :to="'/devis'" class="black">Fermer</router-link>
                  <div class="ball-anchor black"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import garantieFieldsList from "../../mixins/garantieFieldsLists";
import Preloader from "@/components/Preloader";
import Accordes from "./GarantiesAccordesMoto";
import insuranceMethods from "../../mixins/insuranceMethods";
import { CLIENT_CIVILITY } from "../../constants/client";

export default {
  name: "GarantieMotoView",
  mixins: [garantieFieldsList, insuranceMethods],
  components: {
    Preloader,
    Accordes,
  },
  data() {
    return {
      isBusy: false,
      isBusyResend: false,
      insurance: {
        address: null,
        category: null,
        city: null,
        civility: null,
        email: null,
        first_name: null,
        last_name: null,
        tel: null,
        zip: null,
      },
      showRetourButton: false,
      CLIENT_CIVILITY,
      pdfWindow: null,
      numberOfDuplicates: 0,
    };
  },
  computed: {
    getDownloadLink() {
      if (this.insurance.id)
        return this.getApiAuthUrl("garantie/generate-pdf/" + this.insurance.id);

      return "";
    },
    getDownloadLinkWL() {
      if (this.insurance.id)
        return this.getApiAuthUrl(
          "garantie/generate-pdfWL/" + this.insurance.id
        );

      return "";
    },
    getDownloadLinkConfirmationPdf() {
      if (this.insurance.id)
        return this.getApiAuthUrl(
          "garantie/confirmation-pdf/" + this.insurance.id
        );

      return "";
    },
    getDownloadLinkCopyPdf() {
      if (this.insurance.id)
        return this.getApiAuthUrl(
          "garantie/front-copy-pdf/" + this.insurance.id
        );

      return "";
    },
    getDownloadLinkCopyPdfWL() {
      if (this.insurance.id)
        return this.getApiAuthUrl(
          "garantie/front-copy-pdfWL/" + this.insurance.id
        );

      return "";
    },
    getPrice() {
      return this.insurance.price
        ? this.roundEURWithoutSymbol(this.insurance.price).replace(".", ",") +
        " €"
        : "";
    },
    getGarantiePrice() {
      console.log("getGarantiePrice");
      console.log(this.insurance);
      return this.insurance.price && +this.insurance.price > 0;
    },
    mechanicCode() {
      let code =
        this.$store.state.userInfo && this.$store.state.userInfo.mechanic
          ? this.$store.state.userInfo.mechanic.code
          : null;
      return code ? code : "";
    },
  },
  methods: {
    confirmSubscription() {
      this.$confirm({
        message:
          "Les critères du véhicule ne permettent pas de souscrire à la garantie choisie. Etes-vous sûr de vouloir envoyer un devis sans prix à votre client ?",
        button: {
          no: "Non",
          yes: "Oui"
        },
        /**
         * Callback Function
         * @param {Boolean} confirm
         */
        callback: confirm => {
          if (confirm) {
            this.checkSubscription(this.insurance, this.resendEmail)
          }
        }
      });
    },
    getQuoteInfo() {
      this.isBusy = true;
      let url = "garantie/" + this.$route.params.id;
      this.apiGet(url)
        .then((response) => {
          this.isBusy = false;
          this.insurance = response.data.quote;
          this.numberOfDuplicates = response.data.duplicates;
        })
        .catch((error) => {
          this.showErrorNotification(error);
          this.$router.push("/");
        });
    },
    parseCivility(civility) {
      switch (+civility) {
        case 0:
          return "M";
        case 1:
          return "Mlle";
        case 2:
          return "Mme";
        case 3:
          return "Société";
        default:
          return "";
      }
    },
    parseGarantie(garantie) {
      switch (+garantie) {
        case 1:
          return "Standard";
        case 2:
          return "Complète";
        default:
          return "";
      }
    },
    parseCarBrand(brand) {
      return this.list_marque_moto[brand] ? this.list_marque_moto[brand] : "";
    },
    parseSaleDate(details) {
      let day = details.day_circulation,
        month = details.month_circulation - 1,
        year = details.year_circulation;

      day.length < 2 ? (day = "0" + day.toString()) : "";
      month.length < 2 ? (month = "0" + month.toString()) : "";

      let date = this.moment(new Date()).date(day).month(month).year(year);
      return date.format("DD/MM/YYYY");
    },
    parseBirthDate(birthdate) {
      if (birthdate) {
        return this.moment(birthdate).format("DD/MM/Y");
      }

      return "";
    },
    parseCylinder(cylinder) {
      return this.list_cylinders_moto[cylinder]
        ? this.list_cylinders_moto[cylinder]
        : "";
    },
    parseDuration(duraion) {
      switch (+duraion) {
        case 1:
          return "3 Mois";
        case 2:
          return "6 Mois";
        case 3:
          return "12 Mois";
        default:
          return "";
      }
    },
    printInsurance() {
      window.print();
    },
    resendEmail() {
      this.isBusyResend = true;
      let url = "garantie/resend-email/" + this.insurance.id;

      this.apiPost(url, {})
        .then((response) => {
          this.isBusyResend = false;
          if (response.data.quote && response.data.status == "success") {
            this.showSuccessNotification(response.data.message, "");
            this.$set(this.insurance, "was_sent", response.data.quote.was_sent);
          }
        })
        .catch((error) => {
          this.isBusyResend = false;
          this.showErrorNotification(error);
        });
    },
    getConfirmationPDF() {
      this.refreshTokenForce()
        .then((response) => {
          if (this.getDownloadLinkConfirmationPdf) {
            let pdfWindow = window.open(this.getDownloadLinkConfirmationPdf);
            if (pdfWindow) this.pdfWindow = pdfWindow;
          } else {
            this.showWarningNotification("Quote Not Found");
          }
        })
        .catch((error) => {
          this.showErrorNotification(error);
        });
    },
    getPDF() {
      if (this.checkEffectiveDate(this.insurance)) {
        this.refreshTokenForce()
          .then((response) => {
            if (this.getDownloadLink) {
              window.open(this.getDownloadLink);
              window.location.href = "/merci";
            } else {
              this.showWarningNotification("Quote Not Found");
            }
          })
          .catch((error) => {
            this.showErrorNotification(error);
          });
      } else {
        this.showWarningNotification(
          "La garantie ne peut-être souscrite à une date antérieur. <br> Veuillez modifier la date de prise d'effet de la garantie."
        );
      }
    },
    getFrontPdf() {
      this.refreshTokenForce()
        .then((response) => {
          if (this.getDownloadLinkCopyPdf) {
            window.open(this.getDownloadLinkCopyPdf);
          } else {
            this.showWarningNotification("Quote Not Found");
          }
        })
        .catch((error) => {
          this.showErrorNotification(error);
        });
    },
  },
  mounted() {
    this.getQuoteInfo();
    this.$eventBus.$emit("sidebar-set-active-tab", "Garantie Moto");

    if (this.$store.state.backToDevisListActive) {
      this.showRetourButton = true;
      this.$store.dispatch("backToDevisDisable");
    }
  },
  beforeDestroy() {
    this.$eventBus.$emit("sidebar-set-active-tab", "");
  },
  watch: {
    pdfWindow: function () {
      window.location.href = "/merci";
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Garantie/GarantieMotoView.vue